export const preloader = () => {
  const preloader = document.querySelector("[data-wm-preloader]");

  document.addEventListener("wm-showPreloader", () => {
    preloader.hidden = false;
  });

  document.addEventListener("wm-hidePreloader", () => {
    preloader.hidden = true;
  });
};
